import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AssessmentRequestService } from 'src/app/assess-requests/assess-requests.service';
import { environment } from 'src/environments/environment';

export interface RequestItem {
  requestId: string;
  status: string;
  createdOn: string;
  createdBy: string;
  cucCodeOrRecipeId: string;
  markets: string;
}

@Component({
  selector: 'app-create-request-warning-popup',
  templateUrl: './create-request-warning-popup.component.html',
  styleUrls: ['./create-request-warning-popup.component.scss']
})
export class CreateRequestWarningPopupComponent implements OnInit {
@Input() requests: RequestItem[] = [];
@Output() continueClicked = new EventEmitter<void>();
@Output() cancelClicked = new EventEmitter<void>();
loading = false;
loadingMsg = 'Loading..';
  constructor(public assessService: AssessmentRequestService) { }

  ngOnInit(): void {
    this.loading = false;
  }

  cancel() {
    this.loading = true;
    const markets = [...new Set(this.requests.map((item: any) => item.markets))].join(',');
    const data = {
        activityName: 'DuplicateRequestWarning - CancelAction',
        userChoice: 'Cancelled',
        choiceContext:  `User cancelled submission after seeing duplicate request warning ` +
        `for CUC: ${this.requests[0].cucCodeOrRecipeId}, Markets: ${markets}`
      };
    const apiurl = environment.APIFAsT + '/loguserchoice/';
    this.assessService.postUserChoice(apiurl, data).subscribe((response: any[]) => {
      this.cancelClicked.emit();
    },
    (error) => {
    });
    // this.cancelClicked.emit();
  }

  continue() {
    this.loading = true;
    const markets = [...new Set(this.requests.map((item: any) => item.markets))].join(',');
    const data = {
        activityName: 'DuplicateRequestWarning - ConfirmSubmission',
        userChoice: 'Confirmed',
        choiceContext:  `User confirmed submission despite duplicate request warning ` +
        `for CUC: ${this.requests[0].cucCodeOrRecipeId}, Markets: ${markets}`
      };
    const apiurl = environment.APIFAsT + '/loguserchoice/';
    this.assessService.postUserChoice(apiurl, data).subscribe((response: any[]) => {
      this.continueClicked.emit();
    },
    (error) => {
    });
    // this.continueClicked.emit();
  }

}
